import React from "react";
import { positiveColor } from "../../../config/palette";
import "./styles.scss";

export const IconCheck = () => {
  return (
    <svg
      color={positiveColor}
      display="block"
      xmlns="http://www.w3.org/2000/svg"
      role="presentation"
      aria-hidden="true"
      focusable="false"
      viewBox="0 0 20 20"
      data-test-component="StencilIconCheckCircle"
      className="icon-check"
    >
      <path
        fillRule="evenodd"
        fill="currentColor"
        d="M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Zm5.77,6.89-6.25,7.5a1,1,0,0,1-.73.36h0A1,1,0,0,1,8,14.46L4.29,10.71A1,1,0,0,1,5.71,9.29l3,3,5.55-6.66a1,1,0,0,1,1.54,1.28Z"
      ></path>
    </svg>
  );
};
